import { engineers } from '../mock';

export const BOOKING_DEPOSIT = 40;
export const MIN_SESSION_HOURS = 2;
export const BALANCE_DUE_NOTE = 'Remaining balance is due at the studio on session day (cash, Cash App or Zelle).';

export const activeEngineers = engineers.filter((e) => e.active !== false);
export const lowestHourlyRate = Math.min(...activeEngineers.map((e) => e.hourlyRate));
export const lowestBundleRate = Math.min(...activeEngineers.map((e) => e.bundleRate));

export const depositFor = (total) => Math.min(BOOKING_DEPOSIT, Math.max(0, Number(total) || 0));
